module.exports = __webpack_public_path__ + "assets/display-settings.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/display-settings.svg
// module id = 328
// module chunks = 0